import React, { useEffect } from 'react';
import { ArrowRight, CheckCircle, BellDot, DollarSign, BarChart, Blocks, Fingerprint, Book, Lock, MessageCircle, Smartphone } from 'lucide-react';
import { motion, useAnimation } from 'framer-motion';
import '../style/products/quantocollect.css';
import Header from '@/common/Header';
import Footer from '@/common/Footer';
import logo from '../img/quanto_light.webp';

export default function Component() {
  const controls = useAnimation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      controls.start({ opacity: 1, y: 0 });
    }, 500); // Add a delay of 500ms or adjust as needed

    return () => clearTimeout(timeout);
  }, [controls]);

  return (
    <>
      <Header />
      <section className="about-title-section">
        <h2>
          <img
            alt="quantologo"
            src={logo}
            style={{ width: 280, marginLeft: 10, verticalAlign: 'middle', marginBottom: 20 }}
          />
          Collect
        </h2>
      </section>
      <div className="container-collect">
        <div className="background-pattern-collect"></div>
        <div className="content-collect">
          <h1 className="heading-collect">
            Benefits and Features of Quanto Collect
          </h1>
          <p className="description-collect">
          Quanto Collect is designed to help brand distributors efficiently manage and track vendor payments. This user-friendly solution simplifies the collection process, ensuring timely payments and improved cash flow without being a complete ERP solution.          </p>
          
          <div className="features-grid-collect">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={controls}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="feature-card-collect"
              >
                <div className="skew-background-collect"></div>
                <div className="feature-content-collect">
                  <feature.icon className="feature-icon-collect" />
                  <h4 className="feature-title-collect">
                    {feature.title}
                  </h4>
                  <p className="feature-description-collect">{feature.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
          
          <div className="cta-section-collect">
            <h2 className="cta-heading-collect">
              Why Choose Quanto's Payment Collection Tool?
            </h2>
            <p className="cta-description-collect">
              Quanto’s Payment Collection Tool is the ideal solution for brand distributors looking to simplify their payment management processes. Its robust features enhance efficiency, improve cash flow, and streamline vendor interactions, making it a valuable addition to any distribution business.
            </p>
            <button className="cta-button-collect">
              Transform Your Collections
              <ArrowRight className="cta-icon-collect" />
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

const features = [
  { icon: CheckCircle, title: "Streamlined Payment Tracking", description: "Easily track and manage payments from multiple vendors, ensuring no payments are missed or delayed." },
  { icon: BellDot, title: "Automated Reminders", description: "Set up automated payment reminders for vendors to enhance timely collections and improve cash flow." },
  { icon: BarChart, title: "Centralized Dashboard", description: "Access a centralized dashboard to monitor all payment activities, providing a clear overview of pending, completed, and overdue payments." },
  { icon: DollarSign, title: "Flexible Payment Methods", description: "Support various payment methods, including online payments, bank transfers, and checks, to cater to vendor preferences." },
  { icon: BarChart, title: "Customizable Reporting", description: "Generate customizable reports on payment collections, helping analyze trends and make informed decisions." },
  { icon: Blocks, title: "Integration with Existing Systems", description: "Seamlessly integrate with Quanto ERP or other accounting software to ensure smooth data flow and minimize manual entry." },
  { icon: Fingerprint, title: "User-Friendly Interface", description: "Enjoy an intuitive interface that simplifies the payment collection process, making it easy for users to navigate and operate." },
  { icon: Book, title: "Improved Cash Flow Management", description: "Enhance cash flow by effectively managing and collecting payments, reducing outstanding receivables." },
  { icon: Lock, title: "Secure Payment Processing", description: "Ensure secure processing of payments, safeguarding sensitive financial information." },
  { icon: MessageCircle, title: "Vendor Communication Tools", description: "Facilitate effective communication with vendors through integrated messaging features, allowing for quick clarifications and updates." },
  { icon: Smartphone, title: "Mobile App for Collection Agents", description: "On-ground collection agents can use the mobile app to track pending payments and assigned routes, making collections more efficient and organized." }
];
